import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import JsBarcode from 'jsbarcode';

import Swal from "sweetalert2";
import CourierRatioChecker from "../../components/backend/CourierRatioChecker";

class Orders extends Component {

  state = {
    activeTab: "all",
    page: 1,
    perPage: 10,
    search: "",
    sortColumn: null,
    sortOrder: "asc",
    actionOpen: null,
    orders: [],
    couriers: [], // To store API Courier list
    loading: true,
    // New state for selection
    selectedIds: new Set(),
    bulkStatus: "",
    selectedCourierID: "", // ID or Name of selected courier
    selectedCourierName: "", // ID or Name of selected courier
  };

  componentDidMount() {
    this.fetchOrders();
    this.fetchCouriers();
  }

  fetchCouriers = async () => {
    try {
      const res = await axios.get("/couriers"); // Adjust endpoint as per your API
      if (res.data.status === "success") {
        this.setState({ couriers: res.data.data });
      }
    } catch (error) {
      console.error("Courier Fetch Error:", error);
    }
  };

  fetchOrders = async () => {
    this.setState({ loading: true, selectedIds: new Set() }); // Clear selection on refresh
    try {
      const res = await axios.get("/products/orders");
      if (res.data.status === "success") {
        this.setState({ orders: res.data.data, loading: false });
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch orders", "error");
      this.setState({ loading: false });
    }
  };

  // --- Selection Logic ---
  handleSelectAll = (e, paginatedItems) => {
    const { selectedIds } = this.state;
    const newSelection = new Set(selectedIds);

    if (e.target.checked) {
      paginatedItems.forEach(item => newSelection.add(item.id));
    } else {
      paginatedItems.forEach(item => newSelection.delete(item.id));
    }
    this.setState({ selectedIds: newSelection });
  };

  handleSelectItem = (id) => {
    const { selectedIds } = this.state;
    const newSelection = new Set(selectedIds);
    if (newSelection.has(id)) {
      newSelection.delete(id);
    } else {
      newSelection.add(id);
    }
    this.setState({ selectedIds: newSelection });
  };

  clearSelection = () => {
    this.setState({ selectedIds: new Set(), bulkStatus: "", selectedCourierID: "", selectedCourierName: "" });
  };

  handleBulkStatusChange = (e) => {
    this.setState({ bulkStatus: e.target.value });
  };

  multipleOrderStatus = async () => {
    const { selectedIds, bulkStatus, selectedCourierID, selectedCourierName } = this.state;

    if (!bulkStatus) {
      return Swal.fire("Select Status", "Please select an order status first", "warning");
    }

    // Validation for Courier
    if (bulkStatus === "Courier" && !selectedCourierID && !selectedCourierName) {
      return Swal.fire("Select Courier", "Please select a Courier Name to proceed", "warning");
    }

    const confirm = await Swal.fire({
      title: `Update ${selectedIds.size} Orders?`,
      text: `Status: ${bulkStatus} ${selectedCourierName ? `(${selectedCourierName})` : ''}`,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      confirmButtonText: "Confirm & Update",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.post("/products/orders/bulk-status", {
          ids: Array.from(selectedIds),
          status: bulkStatus,
          courier_id: selectedCourierID, // Sending courier info to backend
        });

        Swal.fire("Success", "Orders updated successfully", "success");
        this.clearSelection();
        this.fetchOrders();
      } catch (err) {
        Swal.fire("Error", "Bulk update failed", "error");
      }
    }
  };


  // --- Bulk Actions ---
  handleBulkDelete = async () => {
    const { selectedIds } = this.state;
    const confirm = await Swal.fire({
      title: `Delete ${selectedIds.size} orders?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete all!",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.post("/products/orders/bulk-delete", { ids: Array.from(selectedIds) });
        Swal.fire("Deleted!", "Selected orders have been removed.", "success");
        this.fetchOrders();
      } catch (err) {
        Swal.fire("Error", "Bulk delete failed", "error");
      }
    }
  };

  downloadCSV = () => {
    const { orders, selectedIds } = this.state;
    const selectedData = orders.filter(o => selectedIds.has(o.id));

    const headers = ["Order ID", "Name", "Phone No", "Address", "Order From", "Order Date&Time", "Payment Type", "Payment Status", "Order Status", "Grand Total"];

    const csvRows = [
      headers.join(","),
      ...selectedData.map(o => [
        o.id,
        `"${o.full_name || ''}"`,
        `"${o.phone || ''}"`,
        `"${o.shipping_address || ''}"`, // Ensure address is in your data object
        o.order_from,
        o.order_datetime,
        o.payment_geteway_id,
        o.payment_status,
        o.order_status,
        o.grand_total
      ].join(","))
    ];

    const blob = new Blob([csvRows.join("\n")], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', `orders_${new Date().getTime()}.csv`);
    a.click();
  };

  // Original methods
  handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This order will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        const res = await axios.delete(`/products/orders/${id}`);
        if (res.data.status === "success") {
          Swal.fire("Deleted!", res.data.message, "success");
          this.fetchOrders();
        }
      } catch (err) {
        Swal.fire("Error", "Failed to delete order", "error");
      }
    }
  };

  handleTabChange = (tab) => this.setState({ activeTab: tab, page: 1 });
  handleSort = (col) => {
    const { sortColumn, sortOrder } = this.state;
    this.setState({
      sortColumn: col,
      sortOrder: sortColumn === col && sortOrder === "asc" ? "desc" : "asc",
    });
  };

  handlePerPage = (e) => this.setState({ perPage: parseInt(e.target.value), page: 1 });
  handleSearch = (e) => this.setState({ search: e.target.value, page: 1 });
  toggleAction = (id) => this.setState({ actionOpen: this.state.actionOpen === id ? null : id });

  printInvoices = async () => {
    const { selectedIds } = this.state;

    if (selectedIds.size === 0) {
      Swal.fire("No selection", "Please select at least one order", "warning");
      return;
    }

    try {
      // Fetch full invoice data for selected orders
      const res = await axios.post("/products/orders/bulk-details", {
        ids: Array.from(selectedIds),
      });

      if (res.data.status !== "success") {
        Swal.fire("Error", "Failed to load invoice data", "error");
        return;
      }

      const orders = res.data.data; // [{ order, items }]

      const win = window.open("", "_blank", "width=900,height=700");

      win.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title>Print Invoices</title>
  <style>
    @page { size: A4; margin: 15mm; }
    body { font-family: Arial, sans-serif; font-size: 12px; }

    .invoice {
      page-break-after: always;
      background: #fff;
      padding: 20px;
    }

    table { width: 100%; border-collapse: collapse; }
    table, th, td { border: 1px solid #000; }
    th, td { padding: 6px; font-size: 12px; }

    .table-dark { background: #000; color: #fff; }
    .text-end { text-align: right; }
    .text-center { text-align: center; }
    .border-bottom { border-bottom: 1px solid #ccc; }
    .small { font-size: 11px; }
  </style>
</head>
<body>

${orders.map(({ order, items }) => `
  <div class="invoice">

    <!-- HEADER -->
    <div style="display:flex; justify-content:space-between; margin-bottom:15px" class="border-bottom">
      <div>
        <h3 style="margin:0">INVOICE</h3>
        <div class="small">Invoice No: INV-${order.id}</div>
        <div class="small">Date: ${order.order_datetime}</div>
      </div>

      <div style="text-align:right">
        <strong>${order.business_name || "Your Shop Name"}</strong>
        <div class="small">${order.phone || ""}</div>
      </div>
    </div>

    <!-- CUSTOMER -->
    <h4>Customer Information</h4>
    <div style="border:1px solid #ccc; padding:10px; margin-bottom:15px">
      <div class="small"><strong>Name:</strong> ${order.full_name}</div>
      <div class="small"><strong>Phone:</strong> ${order.phone}</div>
      ${order.email ? `<div class="small"><strong>Email:</strong> ${order.email}</div>` : ``}
      <div class="small"><strong>Address:</strong> ${order.shipping_address}</div>
      <div class="small"><strong>Division:</strong> ${order.division_name}</div>
    </div>

    <!-- ITEMS -->
    <h4>Order Items</h4>
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Product</th>
          <th class="text-center">Qty</th>
          <th class="text-end">Price</th>
          <th class="text-end">Subtotal</th>
        </tr>
      </thead>
      <tbody>
        ${items.map((it, i) => `
          <tr>
            <td>${i + 1}</td>
            <td>${it.product_name}</td>
            <td class="text-center">${it.quantity}</td>
            <td class="text-end">৳${it.price}</td>
            <td class="text-end">৳${it.sub_total}</td>
          </tr>
        `).join("")}

        <tr>
          <td colspan="4" class="text-end"><strong>Delivery Charge</strong></td>
          <td class="text-end">৳${order.delivery_charge}</td>
        </tr>

        <tr>
          <td colspan="4" class="text-end"><strong>Coupon Discount</strong></td>
          <td class="text-end">− ৳${order.coupon_discount}</td>
        </tr>

        <tr>
          <td colspan="4" class="text-end"><strong>Discount</strong></td>
          <td class="text-end">− ৳${order.discount}</td>
        </tr>

        <tr class="table-dark">
          <td colspan="4" class="text-end"><strong>Grand Total</strong></td>
          <td class="text-end"><strong>৳${order.grand_total}</strong></td>
        </tr>
      </tbody>
    </table>

    ${order.order_note ? `
      <div style="margin-top:10px" class="small">
        <strong>Order Note:</strong> ${order.order_note}
      </div>
    ` : ``}

    <div style="text-align:center; margin-top:20px" class="small">
      Thank you for your order! | Powered By Fylance
    </div>

  </div>
`).join("")}

</body>
</html>
    `);

      win.document.close();
      win.focus();
      win.print();

    } catch (err) {
      Swal.fire("Error", "Bulk invoice print failed", "error");
    }
  };

  printLabels = async () => {
    const { selectedIds } = this.state;

    if (selectedIds.size === 0) {
      Swal.fire("No selection", "Please select at least one order", "warning");
      return;
    }

    try {
      const res = await axios.post("/products/orders/bulk-details", {
        ids: Array.from(selectedIds),
      });

      if (res.data.status !== "success") {
        Swal.fire("Error", "Failed to load order data", "error");
        return;
      }

      const orders = res.data.data;

      const win = window.open("", "_blank", "width=900,height=700");

      win.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title>4x6 Labels</title>

  <style>
    @page {
      size: 4in 6in;
      margin: 0;
    }

    body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      font-size: 11px;
    }

    .label {
      width: 101.6mm;
      height: 152.4mm;
      box-sizing: border-box;
      padding: 8mm;
      border: 1px solid #000;
      page-break-after: always;
    }

    .row {
      margin-bottom: 4px;
    }

    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 6px;
      text-align: center;
    }

    .barcode {
      margin-top: 12px;
      text-align: center;
    }
    .powered-by {
      margin-top: 6px;
      text-align: center;
      font-size: 10px;
      font-weight: bold;
    }
  </style>
</head>
<body>
<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
${orders.map(({ order, items }) =>
        items.map((item, i) => `
    <div class="label">
      <div class="row"><strong>Merchant:</strong> ${order.business_name || "Your Shop"}</div>
      <div class="row"><strong>Customer:</strong> ${order.full_name || ""}</div>
      <div class="row"><strong>Phone:</strong> ${order.phone || ""}</div>
      <div class="row"><strong>Address:</strong> ${order.shipping_address || ""}</div>
      <div class="row"><strong>Order ID:</strong> ${item.id || ""}</div>
      <div class="row"><strong>Amount:</strong> ${order.grand_total || ""}</div>
      <div class="barcode">
        <svg id="barcode-${order.id}-${i}"></svg>
      </div>
      <div class="powered-by">Powered By Fylance</div>
    </div>
  `).join("")
      ).join("")}
<script>
  window.onload = function () {
    ${orders.map(({ order, items }) =>
        items.map((item, i) => `
        if ("${item.id}") {
          JsBarcode(
            "#barcode-${order.id}-${i}",
            "${item.id}-${order.grand_total}",
            {
              format: "CODE128",
              width: 2,
              height: 50,
              displayValue: true,
              fontSize: 12,
              margin: 0
            }
          );
        }
      `).join("")
      ).join("")}
    // Auto print (optional)
    // window.print();
  };
</script>
</body>
</html>
    `);
      win.document.close();
      win.focus();

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Bulk label print failed", "error");
    }
  };

  render() {

    const { activeTab, orders, search, sortColumn, sortOrder, perPage, page, actionOpen, loading, selectedIds, couriers, bulkStatus, selectedCourierID, selectedCourierName } = this.state;


    let filtered = activeTab === "all" ? orders : orders.filter((o) => (o.order_status || "").toLowerCase() === activeTab.toLowerCase());
    filtered = filtered.filter((o) => Object.values(o).join(" ").toLowerCase().includes(search.toLowerCase()));

    if (sortColumn) {
      filtered.sort((a, b) => {
        if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
        if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    }

    const total = filtered.length;
    const start = (page - 1) * perPage;
    const end = Math.min(start + perPage, total);
    const paginated = filtered.slice(start, end);
    const totalPages = Math.ceil(total / perPage);

    const sortIcon = (col) => sortColumn === col ? (sortOrder === "asc" ? "↑" : "↓") : "↕";

    // Check if all items on current page are selected
    const isAllSelected = paginated.length > 0 && paginated.every(item => selectedIds.has(item.id));

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="card shadow-none">
            <div className="card-body">
              {/* TABS (Existing) */}
              <ul className="nav nav-tabs mb-3 d-flex w-100">
                <div className="d-flex flex-wrap">
                  {["all", "Pending", "Confirm", "On Hold", "Processing", "Shipped", "Courier", "Delivered", "Cancelled", "Return", "Refund", "Trash"].map((key) => (
                    <li className="nav-item" key={key} style={{ marginRight: "-17px" }}>
                      <button className={"nav-link " + (activeTab === key ? "active" : "")} onClick={() => this.handleTabChange(key)}>
                        {key.charAt(0).toUpperCase() + key.slice(1)}
                      </button>
                    </li>
                  ))}
                </div>
                <div className="ms-auto">
                  <Link to="/admin/order/add" className="btn btn-light-warning btn-sm">New Order</Link>
                </div>
              </ul>

              {/* TOP BAR */}
              <div className="d-flex justify-content-between mb-3">
                <div>
                  Show <select value={perPage} onChange={this.handlePerPage}>
                    {[10, 25, 50, 100].map(v => <option key={v} value={v}>{v}</option>)}
                  </select> entries
                </div>
                <input type="text" className="form-control" style={{ width: "250px" }} placeholder="Search..." value={search} onChange={this.handleSearch} />
              </div>

              {/* TABLE */}
              <div className="table-responsive">
                <table className="table table-bordered table-sm table-striped align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "40px" }} className="text-center">
                        <input type="checkbox" className="form-check-input" checked={isAllSelected} onChange={(e) => this.handleSelectAll(e, paginated)} />
                      </th>
                      <th onClick={() => this.handleSort("id")} style={{ cursor: "pointer" }}>ID {sortIcon("id")}</th>
                      <th onClick={() => this.handleSort("customer_name")} style={{ cursor: "pointer" }}>Customer {sortIcon("customer_name")}</th>
                      <th>Phone</th>
                      <th>From</th>
                      <th>Date</th>
                      <th>Payment</th>
                      <th>Status</th>
                      <th>Total</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr><td colSpan={10} className="text-center">Loading...</td></tr>
                    ) : paginated.length === 0 ? (
                      <tr><td colSpan={10} className="text-center">No Orders Found</td></tr>
                    ) : (
                      paginated.map((o) => (
                        <tr key={o.id}>
                          <td className="text-center">
                            <input type="checkbox" className="form-check-input" checked={selectedIds.has(o.id)} onChange={() => this.handleSelectItem(o.id)} />
                          </td>
                          <td style={{ fontSize: '12px' }}>{o.id}</td>
                          <td style={{ fontSize: '12px' }}>{o.full_name || "—"}</td>
                          <td style={{ fontSize: '12px' }}>
                            {o.phone}
                            <div className="d-flex gap-1 mt-1">
                              <a href={`https://wa.me/${o.phone}`} target="_blank" rel="noreferrer"><i className="ph ph-whatsapp-logo text-success" style={{ fontSize: "20px" }}></i></a>
                              <a href={`tel:${o.phone}`}><i className="ph ph-phone text-primary" style={{ fontSize: "20px" }}></i></a>
                              <span
                                style={{
                                  marginTop: "2px",
                                  color: "#3b0ecc",
                                }}
                              >
                                {o.phone && <CourierRatioChecker phone={o.phone} />}
                              </span>
                            </div>
                          </td>
                          <td style={{ fontSize: '12px' }}>{o.order_from}</td>
                          <td style={{ fontSize: '11px' }}>{o.order_datetime}</td>
                          <td style={{ fontSize: '11px' }}>{o.payment_geteway_id}</td>
                          <td>
                            <span className="badge bg-light-primary text-primary">
                              {o.order_status === "Courier"
                                ? `Courier (${o.name}) - ${o.courier_status}`
                                : o.order_status}
                            </span>
                          </td>
                          <td className="fw-bold">{o.grand_total} ৳</td>
                          <td className="position-relative">
                            <button className="btn btn-sm btn-light" onClick={() => this.toggleAction(o.id)}>⋮</button>
                            {actionOpen === o.id && (
                              <div className="position-absolute bg-white border shadow p-2" style={{ right: 0, top: "30px", zIndex: 10, width: "150px", borderRadius: "6px" }}>
                                <Link className="dropdown-item py-1" to={`/admin/order/edit/${o.id}`}><i className="ph ph-pencil-simple me-2"></i> Edit</Link>
                                <Link className="dropdown-item py-1" to={`/admin/order/payments/${o.id}`}><i className="ph ph-money me-2"></i> Payments</Link>
                                <Link className="dropdown-item py-1" to={`/admin/order/details/${o.id}`}><i className="ph ph-eye me-2"></i> Details</Link>
                                <button className="dropdown-item py-1 text-danger" onClick={() => this.handleDelete(o.id)}><i className="ph ph-trash me-2"></i> Delete</button>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* FOOTER */}
              <div className="d-flex justify-content-between mt-3">
                <div>Showing {total === 0 ? 0 : start + 1} to {end} of {total} entries</div>
                <nav>
                  <ul className="pagination pagination-sm">
                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => this.setState({ page: page - 1 })}>Prev</button>
                    </li>
                    <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => this.setState({ page: page + 1 })}>Next</button>
                    </li>
                  </ul>
                </nav>
              </div>

              {/* BULK ACTION POPUP */}
              {selectedIds.size > 0 && (
                <div
                  className="fixed-bottom bg-dark text-white p-3 d-flex align-items-center justify-content-between shadow-lg"
                  style={{ zIndex: 1050, left: "260px" }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <span className="fw-bold">{selectedIds.size} Items selected</span>

                    {/* ✅ STATUS SELECT */}
                    <select
                      className="form-select form-select-sm"
                      style={{ width: "180px" }}
                      value={bulkStatus}
                      onChange={(e) => this.setState({ bulkStatus: e.target.value, selectedCourierID: "", selectedCourierName: "" })}
                    >
                      <option value="">-- Change Status --</option>
                      <option value="Pending">Pending</option>
                      <option value="Confirm">Confirm</option>
                      <option value="On Hold">On Hold</option>
                      <option value="Processing">Processing</option>
                      <option value="Shipped">Shipped</option>
                      <option value="Courier">Move to Courier</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Return">Return</option>
                      <option value="Refund">Refund</option>
                      <option value="Trash">Trash</option>
                    </select>

                    {/* DYNAMIC COURIER SELECTOR - Appears only when Courier status is chosen */}
                    {bulkStatus === "Courier" && (
                      <select
                        className="form-select form-select-sm border-warning animate__animated animate__fadeIn"
                        style={{ width: "200px", backgroundColor: "#fffdf0" }}
                        value={selectedCourierID}
                        onChange={(e) => {
                          const selectedOption = e.target.options[e.target.selectedIndex];
                          this.setState({
                            selectedCourierID: e.target.value,
                            selectedCourierName: selectedOption.text
                          });
                        }}
                      >
                        <option value="">-- Choose Courier --</option>
                        {couriers.map(c => (
                          <option key={c.id} value={c.id}>{c.name}</option>
                        ))}
                      </select>
                    )}
                    <button
                      className="btn btn-sm btn-outline-light"
                      onClick={this.clearSelection}
                    >
                      <i className="ph ph-x me-1"></i> Clear
                    </button>
                  </div>

                  <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-primary" onClick={this.downloadCSV}>
                      Download CSV
                    </button>
                    <button className="btn btn-sm btn-info" onClick={this.printInvoices}>
                      Invoice Print
                    </button>
                    <button
                      className="btn btn-sm btn-warning"
                      onClick={this.printLabels}
                    >
                      Label Print
                    </button>
                    <button
                      className="btn btn-sm btn-success"
                      onClick={this.multipleOrderStatus}
                    >
                      Apply Status
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={this.handleBulkDelete}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Orders;